import { FC } from 'react';

export const DynamicImportFailureFallback: FC = () => (
  <div className="d-flex flex-column">
    <div className="alert alert-danger text-white display-4 d-flex align-items-center justify-content-between">
      <em className="icon icon-lg pe-5">error</em>
      Network issues
    </div>
    <div className="display-5 p-3">
      SG Markets Structured Products seems to have difficulties loading, please refresh the page or press the F5 key on
      your keyboard
    </div>
  </div>
);
